import React from 'react';
import messages from '../../displayMessages';
import { useLayoutSize, WrappedMessage } from 'utils';
import CareerSort from './CareerSort';
import { CareerTagData } from '../CareerHome/career-search';
import CareerFilter from './CareerFilter';
import { Icon, IconSymbol } from 'elements';
import { MessageDescriptor } from 'react-intl';

interface CareerFilterBarProps {
  subjectFilters: CareerTagData[];
  selectedSubjects: CareerTagData[];
  resetSelectedSubjects: () => void;
  educationFilters: CareerTagData[];
  selectedEducation: CareerTagData[];
  resetSelectedEducation: () => void;
  fieldsFilters: CareerTagData[];
  selectedFields: CareerTagData[];
  resetSelectedFields: () => void;
  selectedSortOrder: any;
  resultCount: number;
  onSelectOption: (sortOrder: any) => void;
  onFilterSelect: (filter: CareerTagData) => void;
  closeCollapsible: (id: string) => void;
}

interface CareerFilterConfig {
  label: MessageDescriptor;
  filterList: CareerTagData[];
  selectedFilters: CareerTagData[];
  onReset: () => void;
  iconName: IconSymbol;
  disableSearch?: boolean;
}

const CareerFilterBar: React.FC<CareerFilterBarProps> = ({
  subjectFilters,
  selectedSubjects,
  resetSelectedSubjects,
  educationFilters,
  selectedEducation,
  resetSelectedEducation,
  fieldsFilters,
  selectedFields,
  resetSelectedFields,
  selectedSortOrder,
  resultCount,
  onSelectOption,
  onFilterSelect,
  closeCollapsible,
}) => {
  const isMobile = ['small', 'mobile'].includes(useLayoutSize());
  const filters: CareerFilterConfig[] = [
    {
      label: messages.schoolSubjectsFilterLabel,
      filterList: subjectFilters,
      selectedFilters: selectedSubjects,
      onReset: resetSelectedSubjects,
      iconName: 'career-subjects',
    },
    {
      label: messages.requiredEducationFilterLabel,
      filterList: educationFilters,
      selectedFilters: selectedEducation,
      onReset: resetSelectedEducation,
      iconName: 'education',
      disableSearch: true,
    },
    {
      label: messages.fieldsFilterLabel,
      filterList: fieldsFilters,
      selectedFilters: selectedFields,
      onReset: resetSelectedFields,
      iconName: 'entry-level-jobs',
    },
  ];

  const countTextMessage =
    resultCount === 1
      ? messages.careerResultsCountText
      : messages.careerResultsCountTextPlural;

  return (
    <div className='career-filters'>
      <div className='career-filters-row'>
        {isMobile && (
          // This is just a transparent placeholder to handle left cutout on scroll
          // instead of left padding
          <div className='close-button transparent'>
            <Icon name='career-close' fill='transparent' zoom='4px' />
          </div>
        )}
        {filters.map(
          (
            {
              label,
              filterList,
              selectedFilters,
              onReset,
              iconName,
              disableSearch,
            },
            i
          ) => (
            <CareerFilter
              key={i}
              label={label}
              filterList={filterList}
              selectedFilters={selectedFilters}
              onFilterSelect={onFilterSelect}
              onReset={onReset}
              closeCollapsible={closeCollapsible}
              iconName={iconName}
              resultCount={resultCount}
              disableSearch={disableSearch}
            />
          )
        )}
      </div>
      <div className='career-sort'>
        <span className='results-count'>
          <WrappedMessage
            message={countTextMessage}
            values={{ count: resultCount }}
          />
        </span>
        <CareerSort
          selectedSortOrder={selectedSortOrder}
          onSelectOption={onSelectOption}
        />
      </div>
    </div>
  );
};

export default CareerFilterBar;
